import { LoggedOutLogoMaker } from '@fiverr-private/header/';

export default LoggedOutLogoMaker;
